import React, { useState } from 'react';
import { Modal, Input, Alert } from 'antd';
import useCompletionCodeCreate from '../../gql/hooks/useCompletionCodeCreate';

const ModalCompletionCodes = ( { iltID, finishedCallback  } ) => {
    const [ completionCode, setCompletionCode ] = useState( '' );
    const [ isSaving, setIsSaving ] = useState( false );
    const [ isValid, setIsValid ] = useState( true );
    const { createCode } = useCompletionCodeCreate();

    const handleCodeChange = ( e ) => {
        const { value } = e.target;
        const alphanumericValue = value.replace( /[^a-zA-Z0-9]/g, '' ); 
        setCompletionCode( alphanumericValue.toUpperCase().substring( 0, 10 ) );
    };

    const handleSave = async () => {
        if ( !validate() ) {
            return;
        }

        setIsSaving( true );

        const result = await createCode( iltID, completionCode );
       
        if ( result.success ) {
            if ( finishedCallback )
            { 
                finishedCallback( result.response );
            }
        }

        setIsSaving( false );
    };

    const validate = () => {
        if ( !completionCode || completionCode.length < 3 ) {
            setIsValid( false );
            return false;
        } else {
            setIsValid( true );
            return true;
        }
    };

    const handleCancel = () => {
        finishedCallback();
    };

    return (
        <div>
            <Modal
                open={ true }
                title="Add Completion Code"
                onOk={ handleSave } 
                onCancel={ handleCancel } 
                confirmLoading={ isSaving }
                maskClosable={ false }
                okText="Save"
            >
                <Input
                    maxLength={ 10 } 
                    value={ completionCode }
                    placeholder="Enter up to 10 characters"
                    onChange={ handleCodeChange }
                    showCount
                />

                { !isValid &&
                    <div 
                        className="ant-form-item-explain-error"
                        style={ { marginTop: '10px' } }
                    >
                        Must be at least 3 charcters long
                    </div>
                }

                <Alert
                    style={ { marginTop: '24px' } }
                    type="warning"
                    description="Completion codes must be between 3 and 10 characters long and be alphanumeric, no special characters"
                />
            </Modal>
        </div>
    );
};

export default ModalCompletionCodes;
